const formatDate = (date: Date) => {
    const formattedHours = date.getHours().toString().padStart(2, '0');
    const formattedMinutes = date.getMinutes().toString().padStart(2, '0');
    return `${formattedHours}:${formattedMinutes}`;
};

export const formatFromTo = (from: string, to: string) => {
    return `${formatDate(new Date(from))} – ${formatDate(new Date(to))}`;
};
